<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <NeTree :trackType='1' neType='[mc_cms]'></NeTree>
    </template>
    <template v-slot:right_view>
      <TrackTaskList :trackType='1'></TrackTaskList>
    </template>
  </BasicLayout>
</template>
<script>
import BasicLayout from '../../layouts/BasicLayout';
import NeTree from '../../components/trackconfig/neTree/NeTree';
import TrackTaskList from '../../components/trackconfig/trackTask/TrackTaskList';

export default {
  name: 'SignalTrackPage',
  components: {
    BasicLayout,
    NeTree,
    TrackTaskList
  },
  data() {
    return {
      left: {
        show: true,
        name: this.$t('Track.resourcesList')
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('Track.signManage')}/${this.$t('Track.signTrack')}`
      }
    };
  }
};
</script>